module.exports = __webpack_public_path__ + "img/product1.7a0c18d3.png";